module.exports = "::ng-deep .cdk-overlay-pane{overflow:auto}\n"